var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"toast-transition","enter-active-class":"animated fadeInUp","leave-active-class":"animated fadeOutDown"}},[(!!_vm.message)?_c('div',{staticClass:"toast-alert"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }